import { render, staticRenderFns } from "./DSPSearch_Search.vue?vue&type=template&id=55e07270&"
import script from "./DSPSearch_Search.vue?vue&type=script&lang=js&"
export * from "./DSPSearch_Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports